const CI_FORM = 'ciForm';
const CI_LABEL = 'ciLabel';
const CI_INPUT_WRAPPER = 'ciInputWrapper';
const CI_INPUT = 'ciInput';

export { CI_FORM, CI_LABEL, CI_INPUT_WRAPPER, CI_INPUT };
